import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'
import { envHelper } from '@/helpers/envHelper'
class UserService {
  @observable userData: ServerData.UserData | null = null
  @observable downList:ServerData.DownloadRecord[] =[]
  private initPromise: Promise<void> | null = null

  @computed get isLogin() {
    return this.userData !== null
  }

  @computed get userId() {
    return this.userData?.inviteCode || this.userData?.userId
  }

  // 是否是vip
  @computed get isVip() {
    return this.userData?.userVersion?.version === 'vip'
  }

  // 兑换码数量
  @computed get exchangeCodeCount() {
    return this.userData?.exchangeCodeInfo?.count ?? 0
  }

  constructor() {
    makeObservable(this)
  }

  public init(): Promise<void> {
    if (!this.initPromise) {
      this.initPromise = this.initialize()
    }
    return this.initPromise
  }

  private async initialize(): Promise<void> {
    await this.wxLoginCheck()
    await this.getUserInfo()
    this.updateUtmInfo()
  }

  public async wxLoginCheck(): Promise<void> {
    if (commonUtils.isWechat()) {
      const { code } = commonUtils.getUrlArgs()
      if (code) {
        const { data } = await api.user.loginByWxGzh(code, envHelper.wxLoginScope)
        runInAction(() => {
          this.userData = data
        })
        commonUtils.replaceState({
          delete: ['code'],
        })
      }
    }
  }
  public async getdownloadInfo(){
    const data= await api.ppt.getPptDownloadList()
     this.downList = data.dataList as any
   }
 

  public updateUtmInfo() {
    const { slug_code, utm = '', kword = '' } = commonUtils.getUrlArgs()
    if (utm) {
      localStorage.setItem('utm', utm)
      sessionStorage.setItem('utm', utm)
    }

    if (kword) {
      localStorage.setItem('kword', kword)
      sessionStorage.setItem('kword', kword)
    }

    if (slug_code) {
      localStorage.setItem('slug_code', slug_code)
      sessionStorage.setItem('slug_code', slug_code)
    }

    // const cleanUrl = commonUtils.removeQueryFromUrl(window.location.href)
    // if (window.location.href !== cleanUrl) {
    //   window.history.replaceState(null, document.title, cleanUrl)
    // }
  }

  public getContactQrUrl(from: 'pc' | 'mobile') {
    const { utm, kword, baiduUrl } = this.getLoginParams()
    const hasAd = !!(utm || kword || baiduUrl)
    if (from === 'pc') {
      if (hasAd) {
        switch (utm) {
          default:
            return commonUtils.getStaticFile('images/customer_qr/pc/ad.png')
        }
      } else {
        return commonUtils.getStaticFile('images/customer_qr/pc/home.png')
      }
    } else {
      if (hasAd) {
        switch (utm) {
          case 'zsjy':
            return commonUtils.getStaticFile('images/mobile/mobile/ad-zsjy.png')
          default:
            return commonUtils.getStaticFile('images/mobile/mobile/ad.png')
        }
      } else {
        return commonUtils.getStaticFile('images/customer_wxqr.png')
      }
    }
  }

  public postUserActionRecord(data: PostData.UserActionInfo) {
    try {
      const isMobile = commonUtils.getIsMobile()
      const referer = commonUtils.getUrlArgs().referer || document.referrer
      const defRemark = {
        referer,
        utm: sessionStorage.getItem('utm'),
        kword: sessionStorage.getItem('kword'),
        slugCode: sessionStorage.getItem('slug_code'),
      }
      let remark = data.remark ? { ...defRemark, ...data.remark } : defRemark
      const _data = {
        ...data,
        clientType: !isMobile ? 'pc' : 'mobile',
        remark,
      }
      api.user.postUserActionRecord(_data).catch((e) => {
        console.log(e)
      })
    } catch (error) {}
  }

  @action
  public async getUserInfo(): Promise<ServerData.UserData | null> {
    try {
      const data = await api.user.getUserInfo()
      this.userData = data.data
      return data.data
    } catch (error) {
      return null
    }
  }

  public getLoginParams() {
    let { utm = '', kword = '', bd_vid: bdVid = '' } = commonUtils.getUrlArgs()
    if (!utm) {
      utm = localStorage.getItem('utm') || ''
    }
    if (!kword) {
      kword = localStorage.getItem('kword') || ''
    }
    let bdUrl = ''
    if (!bdVid) {
      bdVid = localStorage.getItem('bdVid') || ''
      bdUrl = localStorage.getItem('bdUrl') || ''
    } else {
      bdUrl = window.location.href
    }
    const baiduUrl = bdVid ? encodeURIComponent(bdUrl) : ''
    return { utm, kword: kword ? decodeFromGb2312(kword) : '', baiduUrl }
  }

  public removeUtmInfo() {
    localStorage.removeItem('utm')
    localStorage.removeItem('kword')
    localStorage.removeItem('bdVid')
    localStorage.removeItem('bdUrl')
  }
  public logout() {
    this.userData = null
    api.user.logout()
  }
}

export const userService = new UserService()
